import axios from "axios";
import { Notification } from "../../config/Global";
import { CONSTANT } from "../../config/Constant";
import { message } from "antd";
import { useSelector } from "react-redux";
import { clearUserPrefs } from "../../utils/listPreferences";

export const setAxiosBaseUrl = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL || "";
};

export const setAxiosHeaders = (token) => {
  const access_token = token;
  if (access_token) localStorage.setItem("token", access_token);
  const auth_token = localStorage.getItem("token");
  if (auth_token && auth_token !== "undefined") {
    return Promise.resolve(auth_token);
  } else {
    return Promise.reject();
  }
};

export const resetStore = () => {
  // clearUserPrefs();
  // localStorage.clear();
  const keepKeys = ["iih.listPrefs.v1"];

  Object.keys(localStorage).forEach((key) => {
    if (!keepKeys.includes(key)) {
      localStorage.removeItem(key);
    }
  });
  window.location.href = CONSTANT.LOGIN_REDIRECT_PATH;
};

export const useCheckPermission = (code, right) => {
  const permissions = useSelector((state) => state.auth.moduleRightsData);

  if (!permissions || !permissions[code]) {
    return false; // Return false if permissions or the specific code does not exist
  }
  return permissions[code]?.includes(right) || false;
};

export const validationErrorNotification = (error) => {
  if (error.isSuccess === false) {
    if (error.data && typeof error.data === "string") {
      // message.error(error.data);
      Notification.error({ message: error.data });
    } else if (error.data !== null && Object.keys(error.data).length === 0) {
      // message.error(error.message);
      Notification.error({ message: error.message });
    } else if (error.data === null) {
      // message.error(error.message);
      Notification.error({ message: error.message });
    } else {
      const msg = (
        <div>
          {Object.entries(error.data).map(([field, messages]) => {
            // Ensure messages is an array
            const messageArray = Array.isArray(messages)
              ? messages
              : [messages];
            return (
              <div key={field} style={{ marginBottom: "1rem" }}>
                <strong>{field}:</strong>
                <ul>
                  {messageArray.map((message, index) => (
                    <li key={index}> - {message}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      );
      Notification.error({ message: "Errors", description: msg });
    }
  }
};
